<template>
  <footer class="footer">
    <ul>
      <li v-for="item in footerLinkItems" :key="item.id">
        <a :href="item.url" :target="item.blank ? '_blank' : false" class="footer-link">{{ item.name }}</a>
      </li>
    </ul>
    <small>Copyright &copy; {{ new Date().getFullYear() }} Lisse</small>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => {
    return {
      footerLinkItemsDefault: [
        {
          id: '1',
          name: '会社概要',
          url: 'https://corp.lisse-law.com/about/company/',
          blank: true
        },
        {
          id: '2',
          name: 'プライバシーポリシー',
          url: 'https://corp.lisse-law.com/policy/privacy-policy/',
          blank: false
        },
        {
          id: '3',
          name: '特定商取引法に基づく表記',
          url: 'https://corp.lisse-law.com/policy/commerce/',
          blank: true
        }
      ]
    };
  },
  computed: {
    footerLinkItems: function () {
      return this.footerLinkItemsDefault;
    }
  }
};
</script>

<style scoped>
.footer {
  height: 50px;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer ul {
  display: flex;
  margin-right: 12px;
}
.footer ul li {
  list-style-type: none;
}
.footer ul li:not(:last-child):after {
  content: '|';
  margin: 0 10px;
}
.footer-link {
  text-decoration: none;
  color: #000;
}
.footer-link:hover {
  color: #26241f;
}
small {
  font-size: 14px;
}
</style>
